module.exports = __webpack_public_path__ + "img/start.49c34722.png";